import { render, staticRenderFns } from "./Grua.vue?vue&type=template&id=486a6622&"
import script from "./Grua.vue?vue&type=script&lang=js&"
export * from "./Grua.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports